// extracted by mini-css-extract-plugin
export default {"layout":"OwnerLayout_layout__gONEK","contentWrapper":"OwnerLayout_contentWrapper__+XYBG","outletWrapper":"OwnerLayout_outletWrapper__msI-x"};